<span class="nw-button__label {{ labelClass }}"><ng-content></ng-content></span>
